// extracted by mini-css-extract-plugin
export var container = "_55-1";
export var cornerButtonContainer = "_55-5";
export var disabled = "_55-2";
export var fileContainer = "_55-4";
export var hiddenInput = "_55-3";
export var widthContainer = "_55-0";